import React, { useState } from "react";
import { Box, Flex, Heading, Text } from "theme-ui";
import ReCAPTCHA from "react-google-recaptcha";
import { graphql } from "gatsby";
import { colors, typography, Icon } from "@greythr/shared-components";
import {
  DemoCustomers,
  CustomerReviewDemo,
} from "../components/demoV2";
import DemoFooter from "../components/demo/DemoFooter";
import formData from "../data/psp_form.yml";
import PSPForm from "../components/psp/PSPForm";

const recaptchaRef = React.createRef();

const PSPFormPage = ({ pageContext: { regionCode }, data }) => {
  const [resetFormVar, setResetFormVar] = useState(false);
  
  return (
    <Box sx={mainContainerStyles}>
      <Box sx={{ mt: ["4rem", "4rem", "4rem", "3rem"], px: "1rem" }}>
        <Heading
          as="h1"
          sx={{ ...typography.h1, color: colors.white, textAlign: "center" }}
        >
          Discover greytHR's Payroll services
        </Heading>
        <Box sx={pageSubtitleStyles}>
          Streamline complex payrolls with enterprise-ready payroll software.
        </Box>
      </Box>
      <Flex sx={demoFormContainerStyles}>
        <Box sx={featureCardContainerStyles}>
          <Heading
            as="h5"
            sx={{
              ...typography.h5,
              color: colors.neutral900,
              mb: "2rem",
            }}
          >
            {formData.featureCard.title}{" "}
            <Text sx={{ color: colors.primary700 }}>
              {formData.featureCard.titleHighlight}
            </Text>
          </Heading>
          <Flex sx={{ flexDirection: "column", gap: "1.5rem" }}>
            {formData.featureCard.features.map((feature, i) => (
              <Flex
                key={`feature-${i}`}
                sx={{
                  alignItems: "flex-start",
                  gap: "0.75rem",
                }}
              >
                <Box sx={{ flexShrink: 0 }}>
                  <Icon
                    name={feature.iconName}
                    color={colors.neutral900}
                    size={24}
                  />
                </Box>
                <Box>
                  <Heading as="h6" sx={featureCardTitleStyles}>
                    {feature.title}
                  </Heading>
                </Box>
              </Flex>
            ))}
          </Flex>
        </Box>
        <Box sx={demoFormStyles}> 
          <PSPForm
            recaptchaRef={recaptchaRef}
            regionCode={regionCode}
            resetFormVar={resetFormVar}
          />
        </Box>
      </Flex>
      <DemoCustomers data={data} />
      <CustomerReviewDemo />
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={process.env.GATSBY_INVISIBLE_RE_CAPTCHA_SITE_KEY}
        badge="bottomright"
      />
      <DemoFooter />
    </Box>
  );
};

export default PSPFormPage;

export const query = graphql`
  query CustomerLogosQuery {
    CustomerLogos: allDatoCmsCustomer(
      filter: {
        enabled: { eq: true }
        customerType: { eq: "psp_customer" }
      }
    ) {
      nodes {
        companyLogo {
          gatsbyImageData(height: 45, layout: CONSTRAINED)
        }
        companyLogoAltText
        companyLogoTitle
      }
    }
  }
`;

export const Head = () => {
  return <meta name="robots" content="noindex,nofollow" />;
};

const {
  mainContainerStyles,
  pageSubtitleStyles,
  demoFormContainerStyles,
  featureCardContainerStyles,
  featureCardTitleStyles,
  demoFormStyles,
} = {
  mainContainerStyles: {
    backgroundColor: colors.primary1000,
    minHeight: "100vh",
    overflow: "hidden",
  },
  pageSubtitleStyles: {
    ...typography.textMd500,
    color: colors.white,
    textAlign: "center",
    mt: "0.5rem",
  },
  demoFormContainerStyles: {
    pt: ["3rem", "3rem", "3rem", "4rem"],
    maxWidth: "80rem",
    mx: "auto",
    px: ["1rem", "1rem", "4rem", "4rem"],
    gap: ["3rem", "3rem", "3rem", "6rem"],
    flexDirection: [
      "column-reverse",
      "column-reverse",
      "column-reverse",
      "row",
    ],
  },
  featureCardContainerStyles: {
    backgroundColor: colors.primary100,
    borderRadius: "1rem",
    overflow: "hidden",
    py: "2rem",
    px: "1.5rem",
    maxWidth: "26.438rem",
    height: "min-content",
    mx: "auto",
  },
  featureCardTitleStyles: {
    ...typography.h6,
    color: colors.neutral900,
    display: "block",
    mb: "0.25rem",
  },
  demoFormStyles: {
    width: "100%",
    flex: "1 1 auto",
    maxWidth: "39.5rem",
    backgroundColor: colors.white,
    borderRadius: "1rem",
    overflow: "hidden",
    height: "100%",
    mx: "auto",
    p: "1.5rem"
  },
};
